import { createApp } from "vue";
import api from "./api";
import App from "./App.vue";
import { createPinia } from "pinia";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia).use(api).mount("#app");
